<!-- YF AI Trade — logo (frequi AppIcon override). Tam renk sembol (mask yerine img). -->
<template>
  <img src="/yf-symbol.png" alt="YF AI Trade" class="object-contain mx-auto" />
</template>
